import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
// import Applications from "pages/Dashboard/applications"

// services
// import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
// import ApplicationFilter from "components/Filter/ApplicationFilter"
import CompanyService from "../../services/applications/Company.service"
import Company from "../Dashboard/companies"

let appService = null
let plasticsUser = null
let staffService = new Staff()
let newCompanyService = null

const AllApplications = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [allCompanies, setAllCompanies] = useState()  


  const toggle = () => {
    setMenu(!menu)
  }


  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    newCompanyService = new CompanyService(userObj)

    setuser(userObj)


     newCompanyService.getCompanies(1).then(response=>{
      if(response.status)
      {
        setAllCompanies(response.data)
        setmounted(true)
      }
    })

 
}, [])

const paginate = page => {
  
    newCompanyService.getCompanies(page).then(response=>{
      if(response.status)
      {
        setAllCompanies(response.data)
        setmounted(true)
      }
    });
    // If we are in search mode, we will call the search endpoint instead
   

  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Companies</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">All Companies</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <Company
                viewOnly={true}
                user={user}
                data={allCompanies}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AllApplications
